import { useEffect, useState } from 'react';
import axios from 'axios';
import { Mic2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AboutHistory = () => {
  const [about, setAbout] = useState(null);
  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/reserve/about`).then(r => setAbout(r.data)).catch(() => setAbout(null));
  }, []);
  if (!about || !about.years?.length) return null;
  const years = [...about.years].sort((a, b) => String(b.year).localeCompare(String(a.year)));

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-cream-100 border-y border-cream-200 overflow-hidden" data-testid="about-history-section">
      <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
      <div className="relative max-w-6xl mx-auto grid lg:grid-cols-[1fr,1.4fr] gap-12 lg:gap-20 items-start">
        <div>
          <p className="eyebrow text-gray-400 mb-4">About the retreat</p>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-gray-900 leading-[1.02] mb-6">
            A history,<br /><span className="italic text-wine">one year at a time.</span>
          </h2>
          <p className="text-base text-gray-600 leading-relaxed" data-testid="about-intro">{about.intro}</p>
        </div>

        <ol className="relative border-l border-[#d9a15b]/50 pl-8 space-y-10" data-testid="history-timeline">
          {years.map((y) => (
            <li key={y.year} className="relative" data-testid={`history-year-${y.year}`}>
              <span className="absolute -left-[41px] top-1.5 w-5 h-5 rounded-full bg-[#1a0d10] border-2 border-[#d9a15b] shadow-[0_0_0_6px_rgba(217,161,91,0.15)]" />
              <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 mb-3">
                <span className="font-display text-4xl font-medium tracking-tighter text-gray-900">{y.year}</span>
                {y.label && <span className="eyebrow text-[10px] text-[#a86f34] tracking-[0.25em]">{y.label}</span>}
                {y.location && <span className="text-xs text-gray-400">{y.location}</span>}
              </div>
              {y.speakers?.length > 0 && (
                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5 md:p-6">
                  <p className="text-[10px] font-semibold tracking-[0.25em] uppercase text-gray-400 mb-3 flex items-center gap-2"><Mic2 className="w-3.5 h-3.5 text-wine" />Speakers</p>
                  <ul className="flex flex-wrap gap-2.5">
                    {y.speakers.map((s) => (
                      <li key={s} className="font-display text-xl md:text-2xl text-gray-900 px-4 py-1.5 rounded-full bg-cream-50 border border-cream-200" data-testid="history-speaker">{s}</li>
                    ))}
                  </ul>
                  {y.note && <p className="text-sm text-gray-500 mt-4 leading-relaxed">{y.note}</p>}
                </div>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default AboutHistory;
